import {
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  LOADER_CHECK,
  LOADER_FALSE,
  VISITOR_LIST,
  SEAT_LIST,
  SEAT_EDIT_MAPPING,
  REMOVE_LIST_MAPPING,
  SEAT_MAPPING_DATA,
  LOCATION_LIST_ALL,
  SEAT_BOOKING_PANNEL,
  GET_SEAT_COORDS,
} from "../type";

const initialState = {
  SeatList: [],
  SeatMapData: [],
  SeatBookingResult: [],
  loader: false,
  RoomResponseEdit: [],
  Roomlistremove: [],
  LocationFilterList: [],
  CoordsList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_UNAUTHENTICATED:
      return initialState;
    case SEAT_LIST:
      return {
        ...state,
        SeatList: action.payload,
        loading: false,
      };
    case SEAT_EDIT_MAPPING:
      return {
        ...state,
        RoomResponseEdit: action.payload,
        loading: false
      }

    case LOCATION_LIST_ALL:
      return {
        ...state,
        LocationFilterList: action.payload,
        loading: false
      }

    case SEAT_BOOKING_PANNEL:
      return {
        ...state,
        SeatBookingResult: action.payload,
        loading: false
      }

    case REMOVE_LIST_MAPPING:
      return {
        ...state,
        Roomlistremove: action.payload,
        loading: false
      }
    case SEAT_MAPPING_DATA:
      return {
        ...state,
        SeatMapData: action.payload,
        loading: false,
      };
    case LOADER_CHECK:
      return {
        ...state,
        loader: true,
      };
    case LOADER_FALSE:
      return {
        ...state,
        loader: false,
      };
    case GET_SEAT_COORDS:
      return {
        ...state,
        CoordsList: action.payload,
        loader: false,
      }
    default:
      return state;
  }
}
